"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Receipt = void 0;
const class_validator_1 = require("class-validator");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const transaction_1 = require("../transaction/transaction");
class Receipt extends mocks_1.Model {
    static userPayableAmount(receipt) {
        return receipt.totalAmount - receipt.discountAmount;
    }
    static companyShare(receipt) {
        return receipt.totalAmount - receipt.discountAmount - receipt.doctorFeeShareAmount;
    }
}
exports.Receipt = Receipt;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Receipt.prototype, "visitId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Receipt.prototype, "totalAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], Receipt.prototype, "doctorFeeShareAmount", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ default: 0 }),
    __metadata("design:type", Number)
], Receipt.prototype, "discountAmount", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], Receipt.prototype, "discountCouponId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], Receipt.prototype, "paymentTransactionId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], Receipt.prototype, "refundTransactionId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], Receipt.prototype, "settlementTransactionId", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'paymentTransactionId', ref: 'Transaction' }),
    __metadata("design:type", transaction_1.Transaction)
], Receipt.prototype, "paymentTransaction", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'refundTransactionId', ref: 'Transaction' }),
    __metadata("design:type", transaction_1.Transaction)
], Receipt.prototype, "refundTransaction", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'settlementTransactionId', ref: 'Transaction' }),
    __metadata("design:type", transaction_1.Transaction)
], Receipt.prototype, "settlementTransaction", void 0);
